import { isEmpty, isString, includes, startsWith, lowerCase } from 'lodash';
import escapeStringRegexp from 'escape-string-regexp';

// local dependencies
import { DATA_TYPES } from 'constants/common';
import { maskString } from 'utils/mask';

// highlight HTML code
const textHighlight = ( text ) => {
	return `<span class='text-pattern-match-highlight'>${ text }</span>`;
};

/**
 * @type {function}
 * @desc An utility function to return a HTML by replacing matched pattern with `span` element.
 *
 * @param { string } value - string value to match pattern against
 * @param { string } pattern - string pattern
 *
 * @example
 * import { textWithPatternMatch } from 'utils/textWithPatternMatch';
 * const HTML = textWithPatternMatch( value );
 */
export const textWithPatternMatch = ( { value, pattern, wildcard = true, type = DATA_TYPES.TEXT } = {} ) => {

    // if `pattern` or `value` is empty, return `value` in a `span` element
    if( ! isEmpty( pattern ) && isString( pattern ) && ! isEmpty( value ) && isString( value ) ) {

		// format `pattern` based on `type` to match the value
		if( type === DATA_TYPES.PHONE ) {
			pattern = maskString( { value: pattern, type: DATA_TYPES.PHONE } );
		}if( type === DATA_TYPES.DATE ) {
			pattern = maskString( { value: pattern, type: DATA_TYPES.DATE } );
		}

		/*---------*/

		// if search is not wildcard, check if `value` starts with `pattern` if not return raw value.
		if( ! wildcard && ! startsWith( lowerCase( value ), lowerCase( pattern ) ) ) {
			return `<span>${ value }</span>`;
		} else {
			return value.replace( new RegExp( escapeStringRegexp( pattern ), 'i' ), ( match ) => {
				return textHighlight( match );
			} );
		}
    } else {
        return `<span>${ value }</span>`;
    }

};

//replace From string
//discard from HTML

export const textWithPatternMatchExcludingHTMLTags = ( value, pattern ) => {

	if( ! isEmpty( pattern ) && isString( pattern ) && ! isEmpty( value ) && isString( value ) ) {
		let result;
		if ( ! includes(  value, '<' ) ) {
			result = value.replace( new RegExp( escapeStringRegexp( pattern ), 'i' ), ( match ) => {
				return textHighlight( match );
			} );
		} else {
			const reg = new RegExp( `[>][^<>.]*\\${ pattern }[^<>.]*[<]`, 'gi' );
			result = value.replace( reg, ( item ) => {
				const subRegex = new RegExp( `\\${ pattern }`, 'gi' );
				return item.replace( subRegex, textHighlight( pattern ) );
			} ) ;
		}
		return result;
	} else {
		return value;
	}

};
